<!--
  Esta es la estructura principal de la aplicación.
-->
<div class="contenedor-principal">
  <!-- MENÚ LATERAL -->
  <app-barra-lateral class="area-lateral"
    [liga]="ligaActual()"></app-barra-lateral>

  <!-- BARRA SUPERIOR CON CONTENIDO DINÁMICO -->
  <div class="area-contenido">
    <app-barra-superior class="barra-superior" 
      [liga]="ligaActual()"></app-barra-superior>

    <!-- MAIN CONTAINER DEL MÓDULO -->
    <main class="contenido-modulo">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<app-env-ribbon></app-env-ribbon>